var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete-custom',{attrs:{"value":_vm.value,"label":_vm.label,"disabled":_vm.disabled,"items":_vm.items,"multiple":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }